import * as _ from 'lodash'
import {ModelPredictorBO} from "./ModelPredictorBO";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";

export class ModelPredictorBOValidations {

    static async ValidateFields(aBO: ModelPredictorBO): Promise<void> {
        const self = aBO

        if (!aBO.WB_ModelPredictor.isActive)
            return

        self.WB_ModelPredictor.cif.MODEL_PREDICTOR_ID = _.trim(self.WB_ModelPredictor.cif.MODEL_PREDICTOR_ID)

        let modelPredictorId = self.WB_ModelPredictor.cif.MODEL_PREDICTOR_ID;

        if (_.isEmpty(modelPredictorId)) {
            self.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "Empty_Id",
                title: "Empty Predictor Id",
                description: 'Model Predictor Id must not be empty: ' + modelPredictorId,
            })
        }


        let modelIdPattern = /[A-Z]+[A-Z_0-9]*/g;
        let matches = modelPredictorId.match(modelIdPattern);
        let firstMatch = (matches == null) ? undefined : matches[0];

        let bValidColumnNameId = (matches?.length == 1) && (modelPredictorId == firstMatch)

        if (!bValidColumnNameId) {

            self.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "Invalid_Id",
                title: "Invalid Predictor Id",
                description: 'Model Predictor Id must contain uppercase/ underscores letters only, got: ' + modelPredictorId,
            })
        }

        /** If compound type then both predictors should be populated **/
        let predictorType = self.WB_ModelPredictor.cif.MODEL_PREDICTOR_TYPE
        if (predictorType == 'Compound') {
            if (
                _.isNull(self.WB_ModelPredictor.cif.WB_MODEL_PREDICTOR_ID_A) ||
                _.isNull(self.WB_ModelPredictor.cif.WB_MODEL_PREDICTOR_ID_B) ||
                (self.WB_ModelPredictor.cif.WB_MODEL_PREDICTOR_ID_A) == 0 ||
                (self.WB_ModelPredictor.cif.WB_MODEL_PREDICTOR_ID_B) == 0 ||
                (self.WB_ModelPredictor.cif.WB_MODEL_PREDICTOR_ID_A) == -1 ||
                (self.WB_ModelPredictor.cif.WB_MODEL_PREDICTOR_ID_B) == -1
            ) {
                self.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "Empty_Component_Predictors",
                    title: "Both predictors A and B are required to be selected for compound predictors",
                    description: 'Both predictors A and B are required to be selected for compound predictors',
                })
            }
        }
        if (predictorType == 'Standard') {
            if (_.isEmpty(self.WB_ModelPredictor.cif.SOURCE_FIELDNAME)) {
                self.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "Empty_Standard_Data_Source_field_name",
                    title: "Field Name from Standard Data Source is empty",
                    description: 'Field Name from Standard Data Source is empty',
                })
            }
            if (_.isEmpty(self.WB_ModelPredictor.cif.WEIGHT_AVERAGING_FIELDNAME)) {
                self.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "Empty_Standard_Data_Source_field_name",
                    title: "WA Field Name from Standard Data Source is empty",
                    description: 'WA Field Name from Standard Data Source is empty',
                })
            }
            if (_.isEmpty(self.WB_ModelPredictor.cif.CUSTOMER_FIELDNAME)) {
                self.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "Empty_Standard_Data_Source_field_name",
                    title: "Customer Field Name from Standard Data Source is empty",
                    description: 'Customer Field Name from Standard Data Source is empty',
                })
            }
            if (_.isEmpty(self.WB_ModelPredictor.cif.PRODUCT_FIELDNAME)) {
                self.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "Empty_Standard_Data_Source_field_name",
                    title: "Product Field Name from Standard Data Source is empty",
                    description: 'Product Field Name from Standard Data Source is empty',
                })
            }
            if (_.isEmpty(self.WB_ModelPredictor.cif.ENTITY_ID_PRODUCT)) {
                self.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "Empty_Standard_Data_Source_field_name",
                    title: "Product Type from Standard Data Source is empty",
                    description: 'Product Type from Standard Data Source is empty',
                })
            }
            if (_.isEmpty(self.WB_ModelPredictor.cif.ENTITY_ID_CUSTOMER)) {
                self.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "Empty_Standard_Data_Source_field_name",
                    title: "Customer Type from Standard Data Source is empty",
                    description: 'Customer Type from Standard Data Source is empty',
                })
            }

            if (_.isEmpty(self.WB_ModelPredictor.cif.PERIOD_METHOD)) {
                self.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "Empty_Standard_Data_Source_field_name",
                    title: "Period Method from Standard Data Source is empty",
                    description: 'Period Method from Standard Data Source is empty',
                })
            }
            if (self.WB_ModelPredictor.cif.PERIOD_METHOD == "dateRange") {
                if (_.isEmpty(self.WB_ModelPredictor.cif.EFFECTIVE_START_DT_FIELDNAME)) {
                    self.ValidateMessageProvider.addMessage({
                        type: MessageType.Error,
                        code: "Empty_Standard_Data_Source_field_name",
                        title: "Period Range field from Standard Data Source is empty",
                        description: 'Period Range field From Standard Data Source is empty',
                    })
                }
                if (_.isEmpty(self.WB_ModelPredictor.cif.EFFECTIVE_END_DT_FIELDNAME)) {
                    self.ValidateMessageProvider.addMessage({
                        type: MessageType.Error,
                        code: "Empty_Standard_Data_Source_field_name",
                        title: "Period Range field from Standard Data Source is empty",
                        description: 'Period Range field To Standard Data Source is empty',
                    })
                }
            }
            if (self.WB_ModelPredictor.cif.PERIOD_METHOD == "periodKey") {
                if (_.isEmpty(self.WB_ModelPredictor.cif.PERIOD_FIELDNAME)) {
                    self.ValidateMessageProvider.addMessage({
                        type: MessageType.Error,
                        code: "Empty_Standard_Data_Source_field_name",
                        title: "Period field from Standard Data Source is empty",
                        description: 'Period field from Standard Data Source is empty',
                    })
                }
                if (_.isEmpty(self.WB_ModelPredictor.cif.ENTITY_ID_PERIOD)) {
                    self.ValidateMessageProvider.addMessage({
                        type: MessageType.Error,
                        code: "Empty_Standard_Data_Source_field_name",
                        title: "Period Level from Standard Data Source is empty",
                        description: 'Period Type from Standard Data Source is empty',
                    })
                }
            }
        }

    }
}
